// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"e3d9674c","223":"e01472d0","280":"64d4c0ad","368":"75f23609","604":"48ae8ec2","888":"28879e6d"}[chunkId] + ".chunk.js";
};